import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const RequireAuth = ({ RequiredFormId }) => {
  const { auth } = useAuth();
  const location = useLocation();

  if (!auth?.forms?.includes(RequiredFormId)) {
    console.error("Auth Form Failed", RequiredFormId);
  }
  // console.log("auth forms>>", auth.forms);
  // console.log("RequiredFormId>>", RequiredFormId);

  return auth?.forms?.includes(RequiredFormId) ? (
    <Outlet />
  ) : auth?.accessToken ? ( //changed from user to accessToken to persist login after refresh
    <Navigate to='/main' state={{ from: location }} replace />
  ) : (
    <Navigate to='/' state={{ from: location }} replace />
  );
};

export default RequireAuth;
